module.exports = __webpack_public_path__ + "static/media/fade.92f39de5.mp3";